module.exports = __webpack_public_path__ + "img/empty_1.00518ba3.png";